module.exports = __webpack_public_path__ + "static/media/maintenanceIcon.31d30217.svg";